import api from '../client';

export const SupportService = {
  getTickets: () => api.get('/support'),
  createTicket: (data) => api.post('/support', data),
  updateTicketStatus: (id, status) => api.patch(`/support/${id}/status`, { status }),
  uploadTicketFile: (id, formData) => api.post(`/support/${id}/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  getComments: (id) => api.get(`/support/${id}/comments`),
  addComment: (id, content) => api.post(`/support/${id}/comments`, { content }),
};